module.exports = __webpack_public_path__ + "static/teaser_ueber-uns-45127f92b8a8bec0df1506457403ff2b.svg";